function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M9 7.586L1.929 0.515 0.515 1.929 7.586 9 0.515 16.071 1.929 17.485 9 10.414 16.071 17.485 17.485 16.071 10.414 9 17.485 1.929 16.071 0.515z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/close.ec5c35de.svg";
export { SvgComponent as ReactComponent };